import React from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet';
import { getGlobalClassnamesForContext } from '../Context';
export var CommonHelmet = function (_a) {
    var language = _a.language, bodyClassName = _a.bodyClassName, theme = _a.theme, themeSkin = _a.themeSkin, flags = _a.flags, isMobile = _a.isMobile;
    return (React.createElement(Helmet, { htmlAttributes: {
            lang: language,
        }, bodyAttributes: {
            class: classnames(getGlobalClassnamesForContext({
                isMobile: isMobile,
                theme: theme,
                flags: flags,
                themeSkin: themeSkin,
            }), bodyClassName),
        } }));
};
CommonHelmet.displayName = 'CommonHelmet';
export default CommonHelmet;
//# sourceMappingURL=CommonHelmet.js.map